// extracted by mini-css-extract-plugin
module.exports = {"today_deals":"TodayDeals_today_deals__ZmbN_"};